function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styles from './ActionButton.module.sass';
import Icon from '../../Icon/Icon';

const ActionButton = ({
  children,
  className,
  primary,
  warning,
  danger,
  icon,
  ...attributes
}) => /*#__PURE__*/React.createElement("button", _extends({
  className: `${styles['button']} ${className || ''}`
}, attributes, {
  primary: primary ? 'true' : 'false',
  warning: warning ? 'true' : 'false',
  danger: danger ? 'true' : 'false'
}), icon && /*#__PURE__*/React.createElement(Icon, {
  className: styles['icon'],
  name: icon
}), /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("strong", null, children)));

export default ActionButton;